import TokenController from '#utils/tokenController';

export const isUser = () => {
  return TokenController.refreshToken ? true : false;
};
